export default __webpack_public_path__ + "static/media/pallavi1.60f5d833.jpg";